import { ApiProperty } from '@nestjs/swagger';
import { DashboardKpiDto } from './dashboard-servicio-integral-response.dto';

/**
 * DTO para item de distribución de sobrestadías (gráfico de torta).
 * Muestra tipo de sobrestadía, cantidad, monto y porcentaje del total.
 */
export class DashboardSobrestadiaDistribucionDto {
  @ApiProperty({
    description: 'Nombre del tipo de sobrestadía',
    example: 'Sobrestadia en puerto',
  })
  tipoSobrestadia!: string;

  @ApiProperty({
    description: 'Cantidad de órdenes de servicio',
    example: 45,
  })
  cantidad!: number;

  @ApiProperty({
    description: 'Monto total en CLP',
    example: 675000,
  })
  montoTotal!: number;

  @ApiProperty({
    description: 'Porcentaje del total',
    example: 35.5,
  })
  porcentaje!: number;
}

/**
 * DTO de respuesta completa del Dashboard Transporte
 */
export class DashboardTransporteResponseDto {
  @ApiProperty({
    description: 'Bloque de KPIs (cantidad O/T, cantidad O/S)',
    example: {
      cantidadOT: { valor: 1669, variacion: 25 },
      cantidadOS: { valor: 5234, variacion: 18 },
    },
  })
  kpis!: {
    cantidadOT: DashboardKpiDto;
    cantidadOS: DashboardKpiDto;
  };

  @ApiProperty({
    description: 'Distribución de sobrestadías agrupadas por tipo',
    type: [DashboardSobrestadiaDistribucionDto],
    example: [
      {
        tipoSobrestadia: 'Sobrestadia en puerto',
        cantidad: 45,
        montoTotal: 675000,
        porcentaje: 35.5,
      },
      {
        tipoSobrestadia: 'Sobrestadia en planta',
        cantidad: 32,
        montoTotal: 480000,
        porcentaje: 25.2,
      },
      {
        tipoSobrestadia: 'Sobrestadia en depósito',
        cantidad: 28,
        montoTotal: 420000,
        porcentaje: 22.1,
      },
    ],
  })
  distribucionSobrestadias!: DashboardSobrestadiaDistribucionDto[];

  @ApiProperty({
    description: 'Distribución de Porteos agrupadas por tipo',
    type: [DashboardSobrestadiaDistribucionDto],
    example: [
      {
        tipoSobrestadia: 'Porteos',
        cantidad: 45,
        montoTotal: 675000,
        porcentaje: 100.0,
      },
    ],
  })
  distribucionPorteos!: DashboardSobrestadiaDistribucionDto[];

  @ApiProperty({
    description: 'Información de la temporada consultada',
    example: { temporadaId: 7, temporadaNombre: '2024 - 2025' },
  })
  temporada!: {
    temporadaId: number;
    temporadaNombre: string;
  };
}
